module.exports = __webpack_public_path__ + "static/img/office (2).a0744110.jpg";